import React from "react";
import "./ProfileCard.css";

import gif from "../../assets/intro.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ProfileCard = () => {
  return (
    <div id="contact" className="flex flex-col sm:flex-row justify-between p-8 bg-dark-5 rounded">
      <div className="sm:w-1/3 image-container mb-10">
        <img className="m-auto image" src={gif} alt="Display Pic" />
      </div>

      <div className="w-2/3 m-auto rounded-3xl">
        <ul className="flex mt-2 gap-8 items-center iconUl">
          <li>
            <a
              href="https://github.com/akd-01"
              rel="noreferrer"
              target="_blank"
              className="github"
            >
              <FontAwesomeIcon size="3x" icon={faGithub} />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/akd-anjali-dubey-2001"
              rel="noreferrer"
              target="_blank"
              className="linkedin"
            >
              <FontAwesomeIcon size="3x" icon={faLinkedinIn} />
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/_Arcane_me_"
              rel="noreferrer"
              target="_blank"
              className="twitter"
            >
              <FontAwesomeIcon size="3x" icon={faTwitter} />
            </a>
          </li>
          <li>
            <a
              href="mailto:dubeyanjali9819@gmail.com"
              rel="noreferrer"
              target="_blank"
              className="mail"
            >
              <FontAwesomeIcon size="3x" icon={faEnvelope} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default ProfileCard;
